import {
  DPUserBankAccount,
  DPProviderBankAccount,
} from "Shared/types/BankAccounts";

const ProviderBankLabel = "DailyPay Account";

const formatBankAccountName = (bankAccountName: string) =>
  bankAccountName.length < 30
    ? bankAccountName
    : bankAccountName.substring(0, 27).trim() + "...";

const getUserBankAccountLabel = (bankAccount: DPUserBankAccount) => {
  const accountLastTwo = bankAccount.accountNumber.slice(-2);
  const primary = bankAccount.primary;
  const accountName = bankAccount.name
    ? ` ${formatBankAccountName(bankAccount.name)}`
    : "";

  return `XX${accountLastTwo} -${accountName}${primary ? " (primary)" : ""}`;
};

const getProviderBankAccountLabel = (
  userFirstName: string,
  bankAccount: NonNullable<DPProviderBankAccount>
) => {
  const accountLastTwo = bankAccount.accountNumber.slice(-2);

  return `XX${accountLastTwo} - ${userFirstName}'s ${ProviderBankLabel}`;
};

export const filterPayableBankAccounts = (
  userFirstName: string,
  providerBankAccount: DPProviderBankAccount,
  userBankAccounts: DPUserBankAccount[]
) => {
  const payableBankAccounts = userBankAccounts.filter((bankAccount) => {
    return bankAccount.creditable === true;
  });
  const options = payableBankAccounts.map((bankAccount) => {
    return {
      value: bankAccount.id,
      label: getUserBankAccountLabel(bankAccount),
      data: "BankAccount",
    };
  });
  // Add DPA if there are any creditable user bank accounts and providerBankAccount is defined
  if (options.length && providerBankAccount) {
    options.push({
      value: providerBankAccount.id,
      label: getProviderBankAccountLabel(userFirstName, providerBankAccount),
      data: "ProviderBankAccount",
    });
  }

  return options;
};
